import { useFormContext } from 'react-hook-form';
import { LwFormInput, LwFormMultiSelect, LwFormTextArea } from 'redesign';
import { Box, Grid, styled, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ServiceAgreementsResponse } from 'ogp/services/service-agreements.types';
import { FlexPoolExternalFormData } from './flex-pool-external.types';

type Props = {
  serviceAgreements: ServiceAgreementsResponse;
};

export const FlexPoolExternalForm = ({ serviceAgreements }: Props) => {
  const { control } = useFormContext<FlexPoolExternalFormData>();
  const { t } = useTranslation(['ogp-screen-specific', 'all-platforms-common']);

  return (
    <Grid container item spacing={6} xs={12}>
      <Grid item xs={6}>
        <form>
          <Grid container item spacing={2} xs={12}>
            <Grid item xs={12}>
              <LwFormInput
                name="name"
                label={t('flexpools.name', { ns: 'all-platforms-common' })}
                control={control}
                rules={{
                  required: t('flexpools.external_create.name_required', {
                    ns: 'ogp-screen-specific',
                  }),
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <LwFormTextArea
                name="description"
                control={control}
                label={t('flexpools.external_create.description_label', {
                  ns: 'ogp-screen-specific',
                })}
              />
            </Grid>
            <Grid item xs={12}>
              <LwFormMultiSelect
                name="serviceAgreements"
                control={control}
                label={t('flexpools.external_create.service_agreements_label', {
                  ns: 'ogp-screen-specific',
                })}
                options={serviceAgreements.map((agreement) => ({
                  id: agreement.id,
                  name:
                    agreement.serviceAgreementPartyRole === 'LENDER'
                      ? agreement.borrowerServiceAgreementParty.name
                      : agreement.lenderServiceAgreementParty.name,
                }))}
                getOptionLabel={(option) => option.name}
                getOptionKey={(option) => option.id}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                data-testid="service-agreements-multiselect"
              />
            </Grid>
          </Grid>
        </form>
      </Grid>
      <Grid item xs={6}>
        <Disclaimer>
          <Typography>{t('flexpools.disclaimer', { ns: 'ogp-screen-specific' })}</Typography>
        </Disclaimer>
      </Grid>
    </Grid>
  );
};

const Disclaimer = styled(Box)(({ theme }) => ({
  background: theme.palette.grey[100],
  padding: theme.spacing(4),
  width: '100%',
  height: '100%',
  borderRadius: theme.shape.borderRadius,
}));
